export const emptyCircuit = {
  circuitGmId: null,
  structureId: null,

  circuitVendorId: "",
  status: null,
  use: null,
  type: null,
  category: null,
  scope: null,

  carrier: null,
  lec: null,

  accessBandwidth: "",
  accessBandwidthConverted: "",
  accessBandwidthUnit: "Mbps",
  portBandwidth: "",
  portBandwidthConverted: "",
  portBandwidthUnit: "Mbps",
  handoffType: null,
  redundancyType: null,

  forecastDeliveryDate: null,
  actualHandoverDate: null,
  cutoverDate: null,
  requestedDisconnectDate: null,
  actualBillingStartDate: null,
  actualBillingStopDate: null,
  currentTermEndDate: null,

  currency: null,
  billToCountry: null,
  mrcBaseline: "",

  circuitNote: "",

  diversityGroupNames: [],
  isNew: true,
};
